import {
  getHealthProfile,
  type HealthProfileSuccessResponseData,
} from "@/services/core-api-adapter";
import { useQuery } from "@tanstack/react-query";

export const healthProfileQueryKey = ["healthProfile"] as const;

export default function useGetHealthProfile() {
  const {
    data: healthProfile,
    isPending,
    isLoading,
    isError: healthProfileFetchError,
    refetch,
  } = useQuery({
    queryKey: healthProfileQueryKey,
    queryFn: async ({ signal }) => {
      const res = await getHealthProfile({ signal });
      if (res && "items" in res) {
        return res as HealthProfileSuccessResponseData;
      }
      throw new Error("Health profile request failed");
    },
  });

  const refetchHealthProfile = refetch;

  return {
    healthProfile: healthProfile ?? null,
    isHealthProfileLoading: isPending || isLoading,
    healthProfileFetchError,
    refetchHealthProfile,
  };
}
